const DEV_DOMAIN = 'dev-allaccess.amaphil.com.ph';

const { protocol, hostname } = window.location;

// BASE URL
const BASE_URL =
  hostname === 'localhost' || hostname === '127.0.0.1'
    ? `https://${DEV_DOMAIN}/api/v1`
    : `${protocol}//${hostname}/api/v1`;

// WEBSOCKET HOST
const WEBSOCKET_HOST =
  hostname === 'localhost' || hostname === '127.0.0.1'
    ? `${DEV_DOMAIN}/socket.io`
    : `${hostname}/socket.io`;

// Placeholder
const AUTO_GENERATED_PLACEHOLDER = 'Auto-Generated by System';

export {
  BASE_URL,
  WEBSOCKET_HOST,
  AUTO_GENERATED_PLACEHOLDER
};
